import SystemOutage from '@zeus/core/SystemOutage';
import { useAuth } from '_/contexts/AuthContext';
import { useSystemAlert } from '_/contexts/SystemAlertContext';
import { Spin } from 'antd';
import React, { Fragment, ReactElement } from 'react';

import MainContent from './MainContent';

const progressContainerStyle = {
  display: 'flex',
  justifyContent: 'center' as const,
  alignItems: 'center' as const,
  height: '100vh',
};

function App(): ReactElement {
  // Use AuthContext instead of Redux for user
  const { isLoading: isLoadingUser } = useAuth();

  // Use SystemAlertContext for system alerts
  const { systemAlert } = useSystemAlert();
  const { outage, message, title } = systemAlert;

  if (outage) {
    return <SystemOutage message={message} title={title} />;
  }

  // Only show loading spinner while actually loading, not if currentUser is null after load
  if (isLoadingUser) {
    return (
      <div style={progressContainerStyle}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Fragment>
      <MainContent />
    </Fragment>
  );
}

export default App;
